import React from 'react';

export const ClockIcon = ({ size = 15, color = 'currentColor' }) => (
  <svg width={size} height={size} viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="7.5" cy="7.5" r="6.5" stroke={color} strokeWidth="1.5" />
    <path d="M7.5 4V7.5L9.5 9.5" stroke={color} strokeWidth="1.5" strokeLinecap="round" />
  </svg>
);



// WEBPACK FOOTER //
// ./src/assets/icons/Clock.icon.jsx